// เลือก player จาก stream.protocol ของ backend ไม่เดาจากนามสกุลไฟล์ เพราะ vendor เดียวกันอาจให้ทั้ง flv และ hls
// ไม่มี iframe: ยิงตรงห้ามเปิดหน้าเว็บที่ backend ให้มา (iframe เปิดอะไรก็ได้ ถึงขั้น javascript: ที่อ่าน token ได้)

import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { PROTOCOL } from '../lib/constants'
import FlvPlayer from './FlvPlayer'
import HlsPlayer from './HlsPlayer'

const BY_PROTOCOL = {
  [PROTOCOL.HTTP_FLV]: FlvPlayer,
  [PROTOCOL.WS_FLV]: FlvPlayer,
  [PROTOCOL.HLS]: HlsPlayer,
}

export default function PlayerHost({ protocol, ...rest }) {
  const Player = BY_PROTOCOL[protocol]

  // ref ให้ effect ข้างล่างไม่ต้องผูกกับฟังก์ชันที่ถูกสร้างใหม่ทุก render
  const onErrorRef = useRef(rest.onError)
  onErrorRef.current = rest.onError

  // ไม่รู้จัก protocol = บั๊คฝั่ง backend แจ้ง error ดีกว่ากรอบดำเงียบ ๆ — ต้องแจ้งจาก effect ห้ามแจ้งตอน render
  // เพราะ onError ปลายทาง setState ด้วย object ใหม่ทุกครั้ง จะวนจน "Maximum update depth exceeded"
  useEffect(() => {
    if (!Player && onErrorRef.current) {
      onErrorRef.current('unknown_protocol', String(protocol))
    }
  }, [Player, protocol])

  if (!Player) return null

  return <Player {...rest} />
}

PlayerHost.propTypes = {
  protocol: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
}
